module.exports = __webpack_public_path__ + "img/0-02-0a-378a8e5225f39574e423ccb50cf14a1f5993b7ee22e34f7aa26799e3062a9e69_16a926d3.ab017979.jpg";